module.exports = __webpack_public_path__ + "img/ic_public_health.95bbebf6.png";